'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Method(eyebrow, title, lead, steps) {
  this.hz = null;
  this.hC = null;
  this.hA = null;
  this.hB = null;
  this.hz = eyebrow;
  this.hC = title;
  this.hA = lead;
  this.hB = steps;
}
export { $c_Lio_intela_sites_intelacloud_content_Method as $c_Lio_intela_sites_intelacloud_content_Method };
$p = $c_Lio_intela_sites_intelacloud_content_Method.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Method;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Method() {
}
export { $h_Lio_intela_sites_intelacloud_content_Method as $h_Lio_intela_sites_intelacloud_content_Method };
$h_Lio_intela_sites_intelacloud_content_Method.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-455537642), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Method)) {
    if ((this.hz === x$0.hz)) {
      var x = this.hC;
      var x$2 = x$0.hC;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.hA === x$0.hA))) {
      var x$3 = this.hB;
      var x$4 = x$0.hB;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "Method";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.hz;
      break;
    }
    case 1: {
      return this.hC;
      break;
    }
    case 2: {
      return this.hA;
      break;
    }
    case 3: {
      return this.hB;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Method(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bA)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Method as $isArrayOf_Lio_intela_sites_intelacloud_content_Method };
var $d_Lio_intela_sites_intelacloud_content_Method = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Method, "io.intela.sites.intelacloud.content.Method", ({
  bA: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Method as $d_Lio_intela_sites_intelacloud_content_Method };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Method.js.map
